module.exports = __webpack_public_path__ + "img/virtual_tour.2b79a62e.jpg";